import React, {useEffect, useRef, useState} from 'react';
import './Chatbot.css';

// Yardımcı fonksiyon: Mesajdaki URL'leri tıklanabilir linke çevir
// Basit bir markdown-to-html dönüştürücü
function simpleMarkdownToHtml(text) {
    if (!text) return '';
    // 1. Başlıkları (## veya #) <h2>/<h1> olarak çevir, başına <br> ekle
    text = text.replace(/^## (.*)$/gm, '<br><h2>$1</h2>');
    text = text.replace(/^# (.*)$/gm, '<br><h1>$1</h1>');

    // 2. Bullet'ları (madde işaretli satırları) <li> olarak çevir
    // Sadece satır başındaki * işaretini ve ardından gelen **başlık**: paragraf yapısını yakala
    text = text.replace(/(^|\n)\s*\*\s*\*\*([^*]+)\*\*:(.*)/g, function (_, p1, title, desc) {
        return p1 + '<li><b>' + title.trim().replace(/^\*+|\*+$/g, '') + ':</b>' + desc.trim().replace(/^\*+|\*+$/g, '') + '</li>';
    });
    // Kalan klasik bullet'ları <li> olarak çevir (gereksiz boşluk ve satır atlamasız)
    text = text.replace(/(^|\n)\s*\* ([^\n]+)/g, function (_, p1, p2) {
        // Başındaki ve sonundaki yıldızları temizle
        return p1 + '<li>' + p2.trim().replace(/^\*+|\*+$/g, '') + '</li>';
    });
    // Birden fazla <li> arka arkaya gelirse tek bir <ul> içine al
    text = text.replace(/(<li>.*?<\/li>)+/gs, function (match) {
        return '<ul>' + match.replace(/\n/g, '') + '</ul>';
    });
    // <ul> ve <li> başına gelen <br> leri temizle
    text = text.replace(/<br>\s*(<ul>)/g, '$1');
    text = text.replace(/<br>\s*(<li>)/g, '$1');

    // Bullet'larda başta/sonda kalan yıldızları ve iki nokta öncesi/sonrası yıldızları temizle
    text = text.replace(/<li>(.*?)<\/li>/gs, function (_, content) {
        // Başta/sonda yıldız ve iki nokta öncesi/yıldızları temizle
        let cleaned = content
            .replace(/\*+:/g, ':') // başlık sonundaki yıldızları kaldır
            .replace(/:\*+/g, ':') // iki nokta sonrası yıldızları kaldır
            .replace(/^\*+/, '')   // baştaki yıldızları kaldır
            .replace(/\*+$/, '')   // sondaki yıldızları kaldır
            .trim();
        return '<li>' + cleaned + '</li>';
    });

    // 3. Bold **text** sadece satır başında veya boşluktan sonra ise <b> olarak çevir
    text = text.replace(/(^|\n|\s)\*\*([^*]+)\*\*(?=\s|\n|$)/g, function (_, before, bold) {
        if (before.endsWith('>')) return before + '<b>' + bold + '</b>';
        if (before === '' || before === '\n') return '<br><b>' + bold + '</b>';
        return before + '<b>' + bold + '</b>';
    });

    // 4. Italic *text* (paragraf içi)
    text = text.replace(/([^>])\*([^*]+)\*/g, function (match, before, italic) {
        if (before.endsWith('>')) return before + '<i>' + italic + '</i>';
        return before + '<br><i>' + italic + '</i>';
    });

    // 5. Linkler [text](url) (öncesine <br> ekle, eğer bir <li> içinde değilse)
    text = text.replace(/(<li>)([^<]*)\[([^\]]+)]\((https?:\/\/[^\s)]+)\)([^<]*)(<\/li>)/g, function (_, li, before, label, url, after, endli) {
        return li + before + '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + '</a>' + after + endli;
    });
    text = text.replace(/([^>])\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/g, function (match, before, label, url) {
        if (before.endsWith('>')) return before + '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
        return before + '<br><a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
    });

    // 6. Düz url'leri anchor'a çevir (sadece anchor etiketi içinde olmayanlar için ve HTML attribute bozulmasını engelle)
    text = text.replace(/(<li>)([^<]*)(https?:\/\/[\w.-]+(?:\/[\w\-./?%&=+#]*)?)([^<]*)(<\/li>)/g, function (_, li, before, url, after, endli) {
        const anchorRegex = new RegExp('<a[^>]+>' + url + '</a>');
        if (anchorRegex.test(text)) return li + before + url + after + endli;
        return li + before + '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>' + after + endli;
    });
    text = text.replace(/(^|\s)(https?:\/\/[\w.-]+(?:\/[\w\-./?%&=+#]*)?)(?=[\s.,;!?)]|$)/g, function (match, space, url) {
        const anchorRegex = new RegExp('<a[^>]+>' + url + '</a>');
        if (anchorRegex.test(text)) return match;
        return space + '<br><a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
    });

    // Gereksiz birden fazla <br> varsa sadeleştir
    text = text.replace(/(<br>\s*){2,}/g, '<br>');
    // <ul> ve <li> içindeki <br> leri temizle
    text = text.replace(/<ul>\s*<br>/g, '<ul>');
    text = text.replace(/<li>\s*<br>/g, '<li>');
    // Mesaj başı <br> kaldır
    text = text.replace(/^<br>/, '');
    return text;
}

const Chatbot = () => {
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [messages, setMessages] = useState([
        {from: 'bot', text: 'Merhaba! Size nasıl yardımcı olabilirim?'}
    ]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        if (open && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }, [messages, open]);

    const callGeminiApi = async (msg) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chatbot/ask-simple`, {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain"
                },
                body: msg
            });
            const data = await response.text();
            return data || "Bir hata oluştu.";
        } catch (err) {
            return "Bir hata oluştu.";
        }
    };

    const handleSend = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;
        const userMessage = {from: 'user', text: input};
        setMessages((prev) => [...prev, userMessage]);
        setInput('');
        setLoading(true);
        const botReply = await callGeminiApi(input);
        setMessages((prev) => [...prev, {from: 'bot', text: botReply}]);
        setLoading(false);
    };

    return (
        <div className={`chatbot-container ${open ? 'open' : ''}`}>
            <button className="chatbot-toggle" onClick={() => setOpen(!open)}>
                💬
            </button>
            {open && (
                <div className={`chatbot-window${expanded ? ' expanded' : ''}`} style={{position: 'relative'}}>
                    <button
                        className="chatbot-expand-btn"
                        title={expanded ? 'Küçült' : 'Büyüt'}
                        onClick={() => setExpanded(e => !e)}
                        aria-label={expanded ? 'Küçült' : 'Büyüt'}
                        style={{left: 8, right: 'auto', top: 8, position: 'absolute'}}
                    >
                        {expanded
                            ? (
                                // Küçült: minimize/restore icon (Material: fullscreen-exit)
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1976d2"
                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 18 15 12"/>
                                    <polyline points="15 18 21 18 21 12"/>
                                    <polyline points="15 12 21 18"/>
                                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                                </svg>
                            ) : (
                                // Büyüt: expand icon (Material: open_in_full)
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1976d2"
                                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="4 9 4 4 9 4"/>
                                    <polyline points="20 15 20 20 15 20"/>
                                    <line x1="4" y1="4" x2="10" y2="10"/>
                                    <line x1="20" y1="20" x2="14" y2="14"/>
                                </svg>
                            )
                        }
                    </button>
                    <div className="chatbot-header">MeduVR Chatbot</div>
                    <div className="chatbot-messages">
                        {messages.map((msg, idx) => {
                            if (msg.from === 'bot') {
                                return (
                                    <div
                                        key={idx}
                                        className={`chatbot-message ${msg.from}`}
                                        dangerouslySetInnerHTML={{__html: simpleMarkdownToHtml(msg.text)}}
                                    />
                                );
                            } else {
                                return (
                                    <div
                                        key={idx}
                                        className={`chatbot-message ${msg.from}`}
                                    >
                                        {msg.text}
                                    </div>
                                );
                            }
                        })}
                        {loading && (
                            <div className="chatbot-message bot chatbot-loading">
                <span className="chatbot-typing">
                  Yanıt yazılıyor
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                </span>
                            </div>
                        )}
                        <div ref={messagesEndRef}/>
                    </div>
                    <form className="chatbot-input-area" onSubmit={handleSend}>
                        <input
                            type="text"
                            value={input}
                            onChange={e => setInput(e.target.value)}
                            placeholder="Mesajınızı yazın..."
                        />
                        <button type="submit">Gönder</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default Chatbot;
